import { DateTime } from "luxon";

const INVALID_INPUTS = ['e', 'E', '+', '-']

export function validateAPIResponse(res, singular, noRes){
  if(res && res['data']) {
    if (singular && res['data'][0]){
      return res['data'][0];
    } else if (!singular) {
      return res['data'];
    } else {
      return noRes;
    }
  } else {
    return noRes;
  }
}

export function dateAsNonTZString(date) {
  // Format plain date without timezone
  if(date instanceof Date)return date.toISOString().split("T")[0];
  if(date instanceof DateTime)return date.toISO().split("T")[0];
}

export function decideVinDisplay (vcl) {
  if(vcl) {
  if(typeof vcl.user_defined_vin === "undefined" || vcl.user_defined_vin === null || vcl.user_defined_vin === 'null' || !vcl.user_defined_vin) {
    return vcl.vin
  } else {
    return vcl.user_defined_vin
  }
  }
}

export function vehicleIdDisplay (vcl) {
  if(vcl) {
    if (vcl.asset_id && vcl.asset_id !== 'null' && vcl.asset_id.toLowerCase() !== 'none') return vcl.asset_id
    if (vcl.user_defined_vin && vcl.user_defined_vin !== 'null') return vcl.user_defined_vin
    if (vcl.vin) return vcl.vin
  }
}


export function formatSimpleDateTime(value) {
  if(!value)return;
  var date = `${value.month}/${value.day}/${value.year}`;  // month day year
  return `${date}`;
}

export function lastFullMonth() {
  // last full month from current date
  var now = DateTime.utc();
  var mth = now.month;
  var yr = now.year;
  var targetMth;
  if (mth === 1) { // If Janurary, roll back to Dec of last year
    targetMth = 12;
    yr = yr-1;
  }
  else {
    targetMth = mth-1;
  }
  var targetStart = DateTime.utc(yr, targetMth, 1);
  var targetEnd = DateTime.utc(yr, mth, 1);
  return {utcStart: formatSimpleDateTime(targetStart), utcEnd: formatSimpleDateTime(targetEnd)};
}

export function getMonth(value) {
  var month;
  switch (value) {
    case "01":
    case "1":
      month = "Jan";
      break;
    case "02":
    case "2":
      month = "Feb";
      break;
    case "03":
    case "3":
      month = "Mar";
      break;
    case "04":
    case "4":
      month = "Apr";
      break;
    case "05":
    case "5":
      month = "May";
      break;
    case "06":
    case "6":
      month = "Jun";
      break;
    case "07":
    case "7":
      month = "Jul";
      break;
    case "08":
    case "8":
      month = "Aug";
      break;
    case "09":
    case "9":
      month = "Sep";
      break;
    case "10":
      month = "Oct";
      break;
    case "11":
      month = "Nov";
      break;
    case "12":
      month = "Dec";
      break;
    default:
      month = "";
  }
  return month;
}

export function roundValue(value, exp) {
  // beginings of new rounding function
  if (typeof exp === 'undefined' || +exp === 0)
    return Math.round(value);

  value = +value;
  exp = +exp;

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
    return NaN;
  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

export function getMapClusterDetails(freq){
  var freqClass;
  var size;
  if(freq > .7) {
    freqClass = "large";
    size = 35;
  } else if(freq > .3) {
    freqClass = "medium";
    size = 30;
  } else {
    freqClass = "small";
    size = 25;
  }
  return  [freqClass, size];
}

// Format number based on user locale, with options adding commas for thousands and decimal places
export function formatNumber(value, userSettings, options = {}) { 
  if (value === null || value === undefined) return;

  // Convert string to number if needed
  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  const locale = userSettings?.currency === 'EUR' ? 'de-DE' : 'en-US';
  const useGrouping = options.useGrouping ?? false; 
  const hasExplicitDecimals = options.decimals !== undefined; 
  const hasMinDecimals = options.minDecimals !== undefined;
  const hasMaxDecimals = options.maxDecimals !== undefined;
  
  if (!useGrouping && !hasExplicitDecimals && !hasMinDecimals && !hasMaxDecimals) { // return value as is
    return numValue.toLocaleString(locale, {
      useGrouping, 
      maximumFractionDigits: 20 // set a high max to avoid truncating decimals if they exist, since we aren't explicitly formatting them
    });
  }

  if (hasMinDecimals || hasMaxDecimals) {
    const minDecimals = hasMinDecimals ? options.minDecimals : 0;
    const maxDecimals = hasMaxDecimals ? options.maxDecimals : 20;
    return numValue.toLocaleString(locale, {
      useGrouping,
      minimumFractionDigits: minDecimals,
      maximumFractionDigits: maxDecimals
    });
  }

  const decimals = hasExplicitDecimals 
    ? options.decimals
    : Number.isInteger(numValue)
      ? 0 // if integer, default to no decimal places
      : 2; // if float, default to 2 decimal places

  return numValue.toLocaleString(locale, {
    useGrouping,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function formatDateString(userSettings, month, year) {
  switch(userSettings.date_display){
    case 'dd/MM/yy':
      return `${month} ${year.slice(2)}`;
    case 'dd/MM/yyyy':
      return `${month} ${year}`;
    case 'MM/dd/yy':
      return `${month} ${year.slice(2)}`;
    case 'MM/dd/yyyy':
      return `${month} ${year}`;
    case 'yy/MM/dd':
      return `${year.slice(2)} ${month}`;
    case 'yyyy/MM/dd':
      return `${year} ${month}`;
    default:
      return `${month} ${year.slice(2)}`;
}
}

export function preventNonIntegers(e) {
  if(INVALID_INPUTS.includes(e.key)) {
    e.preventDefault()
  }
}

export function preventPasteNonIntegers(e) {
  const clipboardData = e.clipboardData;
  let data = clipboardData.getData('text').split('')
  data.forEach((l) => {
    if (INVALID_INPUTS.includes(l)) {
      e.preventDefault()
    }
  })
};

// Converts accented characters to unaccented characters and replaces special EU characters with their unaccented equivalents
// Used to enable accent-insensitive searching and comparison
export function convertToPlainText(value) {
    if (!value) return '';
    return value
        .normalize("NFD") // decomposes combined letters into letter + accent
        .toLowerCase()
        .replace(/\p{M}/gu, "") // removes all accent marks
        // replaces EU special letters that aren't marks
        .replace(/ß/g, "ss") 
        .replace(/æ/g, "ae")
        .replace(/œ/g, "oe")
        .replace(/ø/g, "o")
        .replace(/đ/g, "d")
        .replace(/ł/g, "l");
}
export const calcTotalActivityStats = (totalSummary) => {
    // Note units have already been converted to respect user settings
    // regardless of miles/km label used in this function
    var totalMiles = 0;
    var elecMiles = 0;
    // var totalKwh = 0;
    var mKwh = 0;
    var dailyElecMiles = 0;
    var mKwhCount = 0;
    totalSummary.forEach((v) => {
      const km = Number(v.km) || 0;
      const elec_km = Number(v.elec_km) || 0;
      const days = Number(v.days) || 0;
      const blended_kwh = Number(v.blended_kwh) || 0;
      totalMiles += km;
      elecMiles += elec_km
      // totalKwh += v.blended_kwh
      dailyElecMiles += Number.isNaN(elec_km/Number(days)) ? 0 : elec_km/Number(days);
      // don't want to include PHEVs in elec fuel efficiency values while
      // replacing with dash in table
      if (v.is_bev && blended_kwh > 0){
        // if BEV & has kwh value, calc elec miles / kwh and add to average
        var vclMKwh = elec_km/blended_kwh
        if (vclMKwh >= 0){
          // if mkwh is negative, leave out of average (consistent with table)
          mKwh += vclMKwh
          mKwhCount += 1
        }
      }
    });
    // NOTE we leave out zero kwh vehicles for efficiency average
    var avgMKwh = Number.isNaN(mKwh/mKwhCount) ? 0 : mKwh/mKwhCount;
    // NOTE we include all vehicles for avg elec miles
    var avgElecMiles = Number.isNaN(elecMiles/totalSummary.length) ? 0 : elecMiles/totalSummary.length;  // avg per EV
    var avgDailyElecMiles = Number.isNaN(dailyElecMiles/totalSummary.length) ? 0 : dailyElecMiles/totalSummary.length;  // avg per day per EV
    // NOTE ev count vs total summary length is not the same
    return {avgElecMiles: avgElecMiles, avgMKwh: avgMKwh,
            avgDailyElecMiles: avgDailyElecMiles, totalMiles: totalMiles};
  }

export function sanitizeDownloadString(str) {
  const sanitizedStr = str
    .trim()
    .replace(/[\s/_]/g, "-") // replace spaces, underscores, and slashes with dashes
    .replace(/[^a-zA-Z0-9-]/g, "") // remove non-alphanumeric characters except dashes
    .replace(/-+/g, "-"); // collapse repeated dashes into a single dash

  return sanitizedStr;
}
